export enum MarketReportTransactionType {
  sales = 'Sales',
  leasing = 'Leasing',
}
